import ScrollReveal from '@/components/common/ScrollReveal';
import GradientIcon from '@/components/common/GradientIcon';
import { services } from '@/mocks/landing';
import SectionTitle from './SectionTitle';

export default function Services() {
  const [first, second, ...small] = services;
  return (
    <section className="w-full bg-white pb-16 md:pb-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <SectionTitle title="Full-service support, from launch to scale" />

        <div className="grid grid-cols-2 md:grid-cols-4 md:grid-rows-2 gap-3">
          {/* Two tall feature tiles */}
          {first && (
            <ScrollReveal animation="fade-up" className="row-span-2 rounded-2xl bg-gradient-to-b from-[#e6f0ff] to-[#f7faff] p-5 flex flex-col min-h-[260px]">
              <div className="flex items-start justify-between">
                <h3 className="font-bold text-[#1f2329]">{first.title}</h3>
                <GradientIcon icon={first.icon} tone={first.tone} size="text-xl" />
              </div>
              <p className="mt-2 text-xs text-[#646a73]">{first.text}</p>
              <div className="mt-auto flex justify-center">
                <span className="w-24 h-24 rounded-[28px] bg-white shadow-[0_18px_40px_-18px_rgba(47,81,214,0.55)] flex items-center justify-center">
                  <GradientIcon icon={first.icon} tone={first.tone} size="text-6xl" />
                </span>
              </div>
            </ScrollReveal>
          )}
          {second && (
            <ScrollReveal animation="fade-up" delay={80} className="row-span-2 rounded-2xl bg-gradient-to-b from-[#efe9ff] to-[#faf8ff] p-5 flex flex-col min-h-[260px]">
              <div className="flex items-start justify-between">
                <h3 className="font-bold text-[#1f2329]">{second.title}</h3>
                <GradientIcon icon={second.icon} tone={second.tone} size="text-xl" />
              </div>
              <p className="mt-2 text-xs text-[#646a73]">{second.text}</p>
              <div className="mt-auto flex justify-center">
                <span className="relative w-24 h-24 rounded-full bg-white shadow-[0_18px_40px_-18px_rgba(123,92,255,0.6)] flex items-center justify-center font-heading text-3xl font-extrabold bg-clip-padding">
                  <span className="bg-gradient-to-br from-[#7b5cff] to-[#ff4d8d] bg-clip-text text-transparent">24h</span>
                </span>
              </div>
            </ScrollReveal>
          )}
          {small.map((s, i) => (
            <ScrollReveal key={s.title} animation="fade-up" delay={120 + i * 60} className="rounded-2xl bg-[#f5f6fa] p-4 hover:bg-[#eef1ff] transition-colors">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-bold text-sm text-[#1f2329]">{s.title}</h3>
                <GradientIcon icon={s.icon} tone={s.tone} variant="tile" className="w-8 h-8 rounded-lg" size="text-lg" />
              </div>
              <p className="mt-3 text-[11px] text-[#8f959e] leading-relaxed">{s.text}</p>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
